const lang = window.navigator.language.indexOf('zh') > -1 ? 'zh-CN' : 'en-US' // 浏览器语言

export default{
    localize(state,itemname, key, defaultVal){
        if (state.languagePackage.length <= 0) {
            return defaultVal
        }
        
        var languagePack = state.languagePackage[0]['language'][lang]
        // console.log("languagePack:", JSON.parse(JSON.stringify(languagePack)))
        var base = (languagePack || {})['base']
        var custom = (languagePack || {})['custom']
        var local = (base && base[itemname]) || (custom && custom[itemname])
        if(!local) {
            return defaultVal
        }
        return local[key] || defaultVal
    }
}